import React from 'react'

export const Pig = props => (
  <svg
    width={25}
    height={25}
    viewBox='0 0 25 25'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path 
        d="M19.1154 4.2118C19.3581 4.40131 19.5 4.69207 19.5 5V7.10104C20.2855 7.90265 20.8805 8.89354 21.2099 10H21.5C22.0523 10 22.5 10.4477 22.5 11V14C22.5 14.3788 22.286 14.725 21.9472 14.8944L20.4907 15.6227C19.9822 16.462 19.3026 17.1855 18.5 17.7452V19C18.5 19.5523 18.0523 20 17.5 20H14.5C13.9477 20 13.5 19.5523 13.5 19H12.5C12.5 19.5523 12.0523 20 11.5 20H8.5C7.94772 20 7.5 19.5523 7.5 19V17.7452C6.19203 16.8329 5.20908 15.484 4.76352 13.9089C3.46275 13.5806 2.5 12.4027 2.5 11V10.5C2.5 9.94772 2.94772 9.5 3.5 9.5C4.05228 9.5 4.5 9.94772 4.5 10.5V11C4.5 11.0942 4.51304 11.1855 4.53741 11.2719C4.90159 7.74806 7.87987 5 11.5 5H14.3769L18.2575 4.02987C18.5562 3.95518 18.8727 4.0223 19.1154 4.2118ZM17 9C16.1716 9 15.5 9.67157 15.5 10.5C15.5 11.3284 16.1716 12 17 12C17.8284 12 18.5 11.3284 18.5 10.5C18.5 9.67157 17.8284 9 17 9Z"
    />
  </svg>
)